<section id="sActionCall">
  <div class="flex flex-wrap justify-content-around">
    <div class="text-center">
      <p>
        <a href="https://scubamedic.com/ViewAnnualPolicy.php" target="_blank">
          <p-button
            icon="ph ph-download"
            label="Descargue aquí su certificado" />

          <br />
          <img
            src="assets/img/logotipos/logo-scuba.jpg"
            class="w-14rem mt-2 border-round"
            alt="Logo scubamedic" />
        </a>
      </p>
    </div>

    <div class="text-center">
      <p>
        <a href="https://scubamedic.com/security.php" target="_blank">
          <p-button
            icon="ph ph-arrow-square-out"
            label="Acceso a centros de buceo" />

          <br />
          <img
            src="assets/img/logotipos/logo-dive-center-sin-subtitulo.jpg"
            class="w-14rem mt-2 border-round"
            alt="Logo scubamedic" />
        </a>
      </p>
    </div>
  </div>
</section>
